module.exports = __webpack_public_path__ + "18f685284c6215117909523f8b106db9.svg";